
import { map } from 'rxjs/operators';
import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';


import * as fromApp from '../../../store/app.reducers';

@Component({
    selector: 'app-cart-badge-container',
    templateUrl: './cart-badge-container.component.html',
    styleUrls: ['./cart-badge-container.component.scss']
})
export class CartBadgeContainerComponent implements OnInit {

    @Input() alternateColor = false;
    @Input() badgeStyle = {};
    @Input() badgeOffset = [];
    numOfItems: Observable<number>;

    constructor(private store: Store<fromApp.AppState>) {
    }

    ngOnInit() {
        this.numOfItems = this.store.select(fromApp.getCartGroups).pipe(
            map(groups => groups.reduce((sum, group) => {
                if (group && group.items) {
                    const requestedItems = group.items.filter(item => item.userAdded || item.item.price.amount > 0);
                    return sum + requestedItems.length;
                }
                return sum;
            }, 0)));
    }

}
